import React from "react";
import { motion } from "framer-motion";
import { QuestionMarkCircleIcon, PhoneIcon } from "@heroicons/react/24/outline";
import Button from "../BookingForm/ui/Button";
import { IMAGE_PATHS } from "../../constants/imagePaths";
import { TELEPHONE_NUMBER, COMPANY_NAME } from "../../constants/constant";

interface HeaderProps {
  onHelpClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onHelpClick }) => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-r from-blue-600 to-blue-800 text-white"
    >
      <div className="w-full px-3 sm:px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center space-x-4">
            <motion.img
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2 }}
              src={IMAGE_PATHS.logo_white}
              alt={COMPANY_NAME}
              className="h-16 w-50"
            />
          </div>

          <div className="flex items-center space-x-4">
            <div className="hidden md:flex items-center space-x-2 text-sm">
              <PhoneIcon className="h-4 w-4" />
              <a href={`tel:${TELEPHONE_NUMBER}`} className="hover:underline">
                {TELEPHONE_NUMBER}
              </a>
            </div>
            <Button
              variant="outline"
              className="border-white text-white hover:bg-white hover:text-blue-600"
              onClick={onHelpClick}
            >
              <QuestionMarkCircleIcon className="h-5 w-5 mr-2" />
              Help
            </Button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
